import { BaseScrollGlobalStyle } from '@toggle/design-system';
import React, { FC, Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';

import { Loader } from '~/components/loader/Loader';
import { ToastsLayout } from '~/components/toasts-layout/ToastsLayout';
import { appPaths, authPaths } from '~/routes/app-paths';
import { livePriceWebSocket } from '~/stores/live-price-websocket/livePriceWebSocket';
import { getSession, useAuth } from '~/stores/use-auth/useAuth';

import { AppMetadata } from './components';
import { NotificationAlerts } from './components/notification-alerts/NotificationAlerts';
import { ThemeController } from './components/theme-controller/ThemeController';
import { useNotificationsWs } from './hooks/use-notifications-ws/useNotificationsWs';
import * as S from './Root.styles';
import { useApp } from './stores/use-app/useApp';
import { useNavigator } from './stores/use-navigator/useNavigator';

export const mobileAlfredPaths = [authPaths.login, appPaths.base];

export const Root: FC = () => {
  const { authProcessing, initStores, setAuthProcessing } = useAuth();
  const initialiseLsegEnv = useApp(state => state.initialiseLsegEnv);
  const { listenToNavigator } = useNavigator();

  const location = useLocation();

  useNotificationsWs();

  const initSession = async () => {
    const session = await getSession();
    initialiseLsegEnv();

    if (session) {
      await initStores(session);
    }

    setAuthProcessing(false);
  };

  useEffect(() => {
    initSession();
    listenToNavigator();

    return () => {
      livePriceWebSocket.getState().closeConnection();
    };
  }, []);

  return (
    <>
      <ThemeController />
      <AppMetadata path={location.pathname} />
      <Suspense fallback={<Loader />}>
        {authProcessing ? (
          <Loader />
        ) : (
          <>
            <BaseScrollGlobalStyle />
            <NotificationAlerts />
            <S.StyledOutletWrapper>
              <Outlet />
            </S.StyledOutletWrapper>
          </>
        )}
      </Suspense>
      <ToastsLayout />
    </>
  );
};
